// src/components/Navbar.tsx
import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Logo from "../assets/mrt-web.png";
import LanguageSwitcher from "./LanguageSwitcher";

const Navbar: React.FC = () => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const links = [
    { name: t("navbar.team"), href: "/kadromuz" },
    { name: t("navbar.about"), href: "/hakkimizda" },
    { name: t("navbar.prices"), href: "/fiyat-listesi" },
    { name: t("navbar.blog"), href: "/blog" },
    { name: t("navbar.contact"), href: "/iletisim" },
  ];

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      className={`transition-all duration-300 z-50 w-full flex justify-center ${
        scrolled
          ? "fixed top-0 left-1/2 transform -translate-x-1/2 bg-white/80 backdrop-blur-md shadow-lg rounded-full px-8 h-14 max-w-[90%]"
          : "absolute top-0 left-1/2 transform -translate-x-1/2 bg-transparent h-20 max-w-[90%]"
      }`}
    >
      <div className="w-full flex items-center justify-between px-4 md:px-10">
        {/* Logo */}
        <Link to="/" className="flex-shrink-0">
          <img src={Logo} alt="Logo" className="h-16 sm:h-24 md:h-36" />
        </Link>

        {/* Desktop Menu + Language */}
        <div className="hidden md:flex items-center gap-6">
          <ul className="flex space-x-6 font-medium">
            {links.map((link) => (
              <li key={link.href}>
                <Link
                  to={link.href}
                  className="text-yellow-500 hover:text-yellow-600 transition-colors duration-200"
                >
                  {link.name}
                </Link>
              </li>
            ))}
          </ul>

          {/* Language Switch */}
          <LanguageSwitcher />
        </div>

        {/* Mobile Button */}
        {/* p-2.5 ile tıklama alanı ~44px'e çıkarıldı (Lighthouse tap-target uyarısı) */}
        <button
          className="md:hidden p-2.5 -mr-2.5 text-yellow-500 hover:text-yellow-600 transition-colors duration-200 ml-2"
          onClick={() => setOpen(!open)}
          aria-label={open ? "Menüyü kapat" : "Menüyü aç"}
        >
          {open ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {/* Mobile Menu */}
      <div
        className={`absolute top-full left-0 w-full bg-white shadow-md transition-all duration-300 ease-in-out overflow-hidden md:hidden ${
          open ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <ul className="flex flex-col space-y-4 p-5 font-medium">
          {links.map((link) => (
            <li key={link.href}>
              <Link
                to={link.href}
                className="block text-yellow-500 hover:text-yellow-600 transition-colors duration-200"
                onClick={() => setOpen(false)}
              >
                {link.name}
              </Link>
            </li>
          ))}

          {/* Mobile Language Switch */}
          <li className="pt-2">
            <LanguageSwitcher />
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;